import React from 'react';
import { useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MessagesContext from '../../contexts/messagesContext';
import { updateUserInfo } from '../../redux/User/UserAction';
import { getNamespace } from '../../utils/storage';
import ProfileForm from './ProfileForm';
import { styles } from './styles';
import * as yup from 'yup';
import baseInfoIcon from '../../assets/images/Icon/baseInfo.svg';

const UpdateUserInfo = () => {
    const classes = styles();
    const { messages } = useContext(MessagesContext);
    const user = useSelector((state) => state.user?.userInfo);
    const initialValues = {
        username: user?.username || '',
        first_name: user?.first_name || '',
        last_name: user?.last_name || ''
    };
    const dispatch = useDispatch();
    const validation = yup.object({
        username: yup
            .string()
            .required(messages.validations.required)
            .min(11, messages.validations.phoneNumber)
    });
    const inputs = [
        {
            name: 'username',
            label: messages.username,
            type: 'text'
        },
        {
            name: 'first_name',
            label: messages.firstName,
            type: 'text'
        },
        {
            name: 'last_name',
            label: messages.lastName,
            type: 'text'
        }
    ];
    const handleSubmit = async (values, { setSubmitting }) => {
        const namespace = getNamespace();
        const userInfo = {
            ...values,
            namespace
        };
        setSubmitting(true);
        await dispatch(updateUserInfo(userInfo));
        setSubmitting(false);
    };
    return (
        <>
            <div className={classes.container}>
                <div className={classes.title}>
                    <img src={baseInfoIcon} alt="baseInfo" />
                    <h4>{messages.baseInfo}</h4>
                </div>
                <ProfileForm
                    initialValues={initialValues}
                    inputs={inputs}
                    handleSubmit={handleSubmit}
                    validation={validation}
                />
            </div>
        </>
    );
};

export default UpdateUserInfo;
